import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { ArrowShortLeftSvg } from './ArrowShortLeft';

export const ArrowShortLeftIcon = createIcon('arrowShortLeft', ArrowShortLeftSvg);
/**
 * @deprecated используйте ArrowShortLeftIcon
 */
export const withArrowShortLeftIcon = withIcon('arrowShortLeft', ArrowShortLeftSvg);
